export default __webpack_public_path__ + "static/media/eng.365ed179.svg";